import { useUser } from '@clerk/clerk-react';
import { useRewardsState } from '../../../coordinators/rewards/hooks';
import { RewardIcon } from './RewardIcon';

interface AccountPageProps {
  onBack: () => void;
  onNavigate: (screen: 'points-activity') => void;
}

export const AccountPage = ({ onBack, onNavigate }: AccountPageProps) => {
  const { profile } = useRewardsState();
  const pointsBalance = profile?.pointsBalance ?? 0;
  const { user } = useUser();

  const username = user?.username ?? '—';
  const email = user?.primaryEmailAddress?.emailAddress;

  return (
    <div className='flex min-h-0 flex-1 flex-col'>
      {/* Back row */}
      <button type='button' onClick={onBack}
        className='mb-3 shrink-0 self-start border-none bg-transparent p-0 text-sm font-semibold text-[#FFFFFF]/90 transition-opacity hover:opacity-80'>
        &larr; Settings
      </button>
      <p className='shrink-0 text-[18px] font-semibold text-white' style={{ marginBottom: 14 }}>Account</p>

      {/* Scrollable content */}
      <div className='hr-scroll min-h-0 flex-1 overflow-y-auto' style={{ paddingRight: 4 }}>
        {/* Points box — accent border */}
        <div
          className='rounded-lg bg-[#FFFFFF]/5'
          style={{ padding: 12, border: '1px solid #FBBF24', marginBottom: 12 }}
        >
          <p className='text-[10px] text-[#FFFFFF]/70' style={{ marginBottom: 4 }}>TOTAL TOKENS</p>
          <p className='inline-flex items-center gap-1.5 text-[22px] font-semibold text-white'>
            <RewardIcon size={22} />
            {pointsBalance.toLocaleString()}
          </p>
          <p className='text-[10px] text-[#FFFFFF]/70' style={{ marginTop: 6 }}>Tokens expire one year after earning</p>
          <button type='button' onClick={() => onNavigate('points-activity')}
            className='mt-2 border-none bg-transparent p-0 text-[11px] text-[#FFFFFF]/90 underline transition-opacity hover:opacity-80'>
            Tokens activity
          </button>
        </div>

        {/* Username FrameBox */}
        <div
          className='rounded-lg bg-[#FFFFFF]/8'
          style={{ padding: 10, border: '1px solid rgba(255,255,255,0.15)', marginBottom: 12 }}
        >
          <p className='text-[10px] tracking-[0.4px] text-[#FFFFFF]/70' style={{ marginBottom: 4 }}>USERNAME</p>
          <p className='text-sm font-semibold text-white'>{username}</p>
        </div>

        {/* Email display */}
        {email && (
          <div
            className='rounded-lg bg-[#FFFFFF]/8'
            style={{ padding: 10, border: '1px solid rgba(255,255,255,0.15)' }}
          >
            <p className='text-[10px] tracking-[0.4px] text-[#FFFFFF]/70' style={{ marginBottom: 4 }}>EMAIL</p>
            <p className='text-sm font-semibold text-white'>{email}</p>
          </div>
        )}
      </div>
    </div>
  );
};

